// extracted by mini-css-extract-plugin
export default {"root":"ApplMemberPage_root__wA6MY"};